// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const CtrOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 640 512","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M309 402l-52.5 110h127L331 402h-22zm22-292L383.5 0h-127L309 110h22zm0 303V99h-22v314h22z","fill":"currentColor"}},{"tag":"path","attrs":{"d":"M545.51 275.5l-63.5-63.5-63.52 63.5L482 339l63.51-63.5zm-63.5-11H316v22h166v-22zM639.5 385L576 321.5 512.5 385l63.5 63.5 63.5-63.5zM.49 385L64 448.5l63.5-63.5L64 321.5.5 385zM576 374H64v22h512v-22zM142.5 202l63.5 63.5 63.5-63.5-63.5-63.5-63.5 63.5zm63.5 11h119v-22H206v22z","fill":"currentColor"}}]},"name":"CTR","theme":"outlined"};

const CtrOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={CtrOutlinedSvg} />;
  CtrOutlined.displayName = 'CtrOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(CtrOutlined);
